import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholderText: {
    id: 'expense.components.ExpenseAccountCodeSelect.placeholderText',
    defaultMessage: 'Select an account code',
  },
})
